/**
 * CellAudioPlayer.jsx — single eye-test grid cell's audio element.
 *
 * Extracted verbatim from RenderingStudioLegacyGrid.jsx (§6.6 A1).
 * Plays the cell's last-rendered signed URL and, on a 403/expired-URL
 * error, resigns a fresh URL (up to twice) via `resignRenderedCell`.
 */

import React, { useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { resignRenderedCell } from "../../slices/voiceRenderingSlice";

const CellAudioPlayer = ({ cell }) => {
  const dispatch = useDispatch();
  const lr = cell?.lastRendered;
  const url = lr?.signedUrl || null;
  const retriesRef = useRef(0);

  const handleError = useCallback(() => {
    if (!lr?.cellId) return;
    if (retriesRef.current >= 2) return;
    retriesRef.current += 1;
    dispatch(resignRenderedCell(lr.cellId));
  }, [dispatch, lr?.cellId]);

  if (!url) return <span style={{ color: "#aaa" }}>(no audio)</span>;
  return (
    <audio
      key={url}
      controls
      preload="none"
      src={url}
      onError={handleError}
      className="grid-audio"
    />
  );
};

export default CellAudioPlayer;
